import axios from "axios";

const axiosInstance = axios.create({
  headers: {
    "x-access-token": localStorage.getItem("token") || "",
  },
});

axiosInstance.interceptors.request.use((req) => {
  const token = localStorage.getItem("token") || "";
  if (token) {
    req.headers["x-access-token"] = token || "";
  }
  return req;
});

// if (localStorage.getItem("usertype") == "landlord") {
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const pathname = window.location.pathname;
//     // e.g. "/abc123/edit-profile/landlord"

//     const segments = pathname.split("/").filter(Boolean);
//     const workspaceId = segments[0];
//     console.log(workspaceId, "workspaceIdworkspaceId");
//     // ✅ Validate workspaceId length = 6
//     if (workspaceId && workspaceId.length === 6) {
//       config.headers["x-workspace-id"] = workspaceId;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );
// }
axiosInstance.interceptors.request.use(
  (config) => {
    const userType = localStorage.getItem("usertype");
    if (userType !== "landlord") return config;

    const segments = window.location.pathname.split("/").filter(Boolean);

    const workspaceId = segments[0];

    if (workspaceId?.length === 6) {
      config.headers["x-workspace-id"] = workspaceId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    // You can log the response or modify it here
    return response;
  },
  (error) => {
    // Ignore cancellations - do not log or toast
    if (
      axios.isCancel?.(error) ||
      error?.code === "ERR_CANCELED" ||
      error?.name === "CanceledError" ||
      error?.name === "AbortError"
    ) {
      return Promise.reject(error);
    }

    // Handle error globally
    console.error("Error response:", error);

    if (error.response?.status?.toString() === "403") {
      localStorage.removeItem("token");
      localStorage.removeItem("saveduserid");
      localStorage.removeItem("is_verified");
      localStorage.removeItem("loggedin_by");

      window.location.reload();
    }
    if (error.response?.status?.toString() === "422") {
      window.location.replace(
        `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home`
      );
      //   logout();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
